import { createApp } from "vue";
import App from "../../vue/App.vue";
import TestApp from "../../vue/TestApp.vue";

globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;

(function( $ ) {
	'use strict';

	 $(function() {

		const app = createApp(App);
		const app1 = createApp(TestApp);

		window.onbeforeunload = function(){

			if ( JSON.stringify(app._component.data().store.domelements) != $('#content').val() ){
				return ('Are you sure you want to leave? Changes might be unsaved');
			}
		};

		$('#publish').one('click', function(event){
			event.preventDefault();
			$('.og-overlay').css('display', 'flex');
			$('#content').val(JSON.stringify(app._component.data().store.domelements));
			html2canvas(document.querySelector("#wrapper-inner"), {
				onclone: function (clonedDoc) {
					clonedDoc.querySelector("#wrapper-inner").style.display = 'block';
					clonedDoc.querySelector("#wrapper-inner").classList.add('og-generate');
				},
				windowWidth : 1216,
				windowHeight: 600,
				}).then(canvas => {
					$('#opengraphiqtemplates_data').val(canvas.toDataURL('image/jpeg', 0.7));
					$('#publish').click();
				});

		});

		window.createSort = function(){
			var sortedIDs = $( "#og-postbox-container" ).sortable( "toArray" );
		}

		window.initializeLayers = function(){

			if( $( '#og-postbox-container' ).hasClass('ui-sortable') ) {
				$( '#og-postbox-container' ).sortable("destroy");
			}

			$('#opengraphiqpostcanvas #layers_temp .tabs').tabs({
				active: 0
			}).find('.ui-tabs-nav li').off('keydown');

			if ( ! $( "#layers_temp" ).hasClass("ui-draggable") ) {
				$( "#layers_temp" ).draggable({
					handle: ".layers-header",
					stop: function( event, ui ) {
						if(ui.position.top < -100) {
							ui.position.top = -100;
							$("#layers_temp").css({ top: '-100px' });
						}
						localStorage.setItem( 'ogbarposition', JSON.stringify( ui.position ) );
					},
				});
			}

			if (localStorage.getItem("ogbarposition") !== null) {
				$("#layers_temp").css(JSON.parse( localStorage.getItem("ogbarposition") ));
			}
	
			$( "#og-postbox-container" ).sortable({
			  axis: "y",
			  items: "> .og-postbox",
			  handle: ".og-postbox-header",
			  update: function( event, ui ) {
				var sortedIDs = $(event.target).sortable( "toArray" );
				sortArray(sortedIDs);
			  }
			});

			// 

			// inicijalizacija image buttona
			
			$( ".imagebutton" ).each(function( index ) {
				if ( !$( this ).hasClass( "image-init" )) {

					var buttonclicked = $( this );

					$( this ).click(function(e) {
						e.preventDefault();
						var clickedimg = $(this);
						var image_frame;
						if(image_frame){
							image_frame.open();
						}
						// Define image_frame as wp.media object
						image_frame = wp.media({
									  title: 'Select Media',
									  multiple : false,
									  library : {
										   type : 'image',
									   }
								  });

						image_frame.on('close',function() {
							var selection =  image_frame.state().get('selection');
							if (selection.length > 0 && selection.models[0].attributes.id != '') {
								if(app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).type == "image"){
									app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).src = selection.models[0].attributes.url;
									app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).imgid = selection.models[0].attributes.id;
								} else if (app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).type == "dynimage") {
									app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).backgroundimage = selection.models[0].attributes.url;
									app._component.data().store.domelements.find(x => x.id == buttonclicked.data("layerid")).imgid = selection.models[0].attributes.id;
								}
							}
						});

						image_frame.on('open',function() {
							var selection =  image_frame.state().get('selection');
							var ids = clickedimg.find('.oghiddenid').val().split(',');
							ids.forEach(function(id) {
							  var attachment = wp.media.attachment(id);
							  attachment.fetch();
							  selection.add( attachment ? [ attachment ] : [] );
							});
						});

						image_frame.open();
					});
					
					$( this ).addClass( "image-init" );
				}
				
			});
		}

		window.initializeApp = function(){
			initializeLayers();
		}

		window.deleteOgItem = function( id ){
			let confirmAction = confirm("Are you sure to delete this element?");
			if (id != undefined) {
					if (confirmAction){
					var tmparray = $.grep(app._component.data().store.domelements, function(e){ 
						return e.id != id; 
					});
					app._component.data().store.domelements = tmparray;
					app._component.data().store.targetid = "-1";
					$("#opengraphiqtemplates_selected").val(app._component.data().store.targetid);
				}
			}
		}

		window.sortArray = function(sortedIDs){
			var tmparray = app._component.data().store.domelements;
			var constarray = [];
			constarray = sortedIDs.map(s => tmparray.find(t => t.id == s));
			app._component.data().store.domelements = constarray.slice().reverse();
		}

		window.deleteItem = function(){
			var id = $( ".layer-item-bar.ui-selected" ).parent().attr( "id" );
			if (id != undefined) {
				var tmparray = $.grep(app._component.data().store.domelements, function(e){ 
					return e.id != id; 
				});
				app._component.data().store.domelements = tmparray;
			}
		}

		window.resizestop = function(event, ui){
			app._component.data().store.domelements.find(x => x.id == $(event.target).attr("id")).style = $(event.target).attr("style");
		}

		if ( $('#opengraphiqpostcanvas').length ) {

			app.mount("#opengraphiqpostcanvas");
			
			if ($("#content").val() != ''){
				app._component.data().store.domelements = JSON.parse($("#content").val());
			}

			if ($("#opengraphiqtemplates_selected").val() != ''){
				app._component.data().store.targetid = $("#opengraphiqtemplates_selected").val();
			}
		}

		app1.mount("#opengraphiqtestcanvas");

		$('#og_test_button').on('click', (event) => {

			var opengraphiqnonce = $("#og_test_template_nonce").val();
			var opengraphiqcurrentid = $("#og_test_id").val();
			var opengraphtemplatedata = JSON.stringify(app._component.data().store.domelements);

			$(".og-ajax-result").remove();
			$('#test-canvasImg').html('<img src="" alt="">');
			$("#og_test_button").after('<div class="og-ajax-result working">' + adminJStranslations.working + '</div>');
			$('#og_test_button').hide();

			jQuery.ajax({
				method : "POST",
				url : opengraphiqAjax.ajaxurl,
				data : {action: "test_ajax", og_test_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid, template_data: opengraphtemplatedata},
			}).done( function(msg) {
				if ( msg == 'false' ){
					$('#og_test_button').show();
					$(".og-ajax-result").removeClass("working").addClass("cancelled");
					$(".og-ajax-result").html(adminJStranslations.nonxisting);
				} else {
					app1._component.data().teststore.domelements = JSON.parse(msg);
				}
				
			});
		});

		window.opengraphmakeshot = function(){
			
			html2canvas(document.querySelector("#test-wrapper-inner"), {
				onclone: function (clonedDoc) {
					clonedDoc.querySelector("#test-wrapper-inner").style.visibility = 'visible';
					clonedDoc.querySelector("#test-wrapper-inner").classList.add('og-generate');
				},
				windowWidth : 1216,
				windowHeight: 600,
				}).then(canvas => {
					$('#og_test_button').show();
					var canvasImg = canvas.toDataURL("image/jpg", 0.8);
					$('#test-canvasImg').html('<img src="'+canvasImg+'" alt="">');
					$(".og-ajax-result").removeClass("working").addClass("finished");
					$(".og-ajax-result").html(adminJStranslations.finished);
				});
		}

		window.addEventListener("keydown", function(e){
			if (app._component.data().store.targetid != "-1" && $(document.activeElement).is('body')){
				if(["ArrowUp"].indexOf(e.code) > -1) {
					app._component.data().store.domelements.find(x => x.id == app._component.data().store.targetid).frame.translatey--;
					e.preventDefault();
				}
				if(["ArrowDown"].indexOf(e.code) > -1) {
					app._component.data().store.domelements.find(x => x.id == app._component.data().store.targetid).frame.translatey++;
					e.preventDefault();
				}
				if(["ArrowRight"].indexOf(e.code) > -1) {
					app._component.data().store.domelements.find(x => x.id == app._component.data().store.targetid).frame.translatex++;
					e.preventDefault();
				}
				if(["ArrowLeft"].indexOf(e.code) > -1) {
					app._component.data().store.domelements.find(x => x.id == app._component.data().store.targetid).frame.translatex--;
					e.preventDefault();
				}
				if(["Delete"].indexOf(e.code) > -1) {
					deleteOgItem(app._component.data().store.targetid);
					$("#opengraphiqtemplates_selected").val(app._component.data().store.targetid);
					e.preventDefault();
				}
			}
		}, false);

		$( '#wrapper' ).on( 'click', function(e){
			app._component.data().store.targetid = "-1";
			$("#opengraphiqtemplates_selected").val(app._component.data().store.targetid);
		});
		
	});

})( jQuery );
